import React from 'react'
import Toolbar from '../Page/Toolbar'
import ToolbarButton from '../Page/ToolbarButton'
import ClipboardIcon from '@material-ui/icons/Assignment'
import CloseIcon from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	input: {
		flex: 1,
		backgroundColor: 'transparent',
		borderWidth: '0px',
		fontFamily: theme.typography.fontFamily,
	}
})

class Permalink extends React.Component {

	constructor(props) {
		super(props)
		this.urlTextFieldRef = React.createRef()
	}

	selectText() {
		this.urlTextFieldRef.current.select()
	}

	copyTextAndClose() {
		this.selectText()
		document.execCommand("copy")
		this.close()
	}

	close() {
		this.props.onClose()
	}

	permalinkUrl() {
		return [
			window.location.origin,
			window.location.pathname,
			"#",
			this.props.stompunktId
		].join("")
	}

	render() {
		return (
			<Toolbar>
				<input
					type = "text"
					value = {this.permalinkUrl()}
					ref = {this.urlTextFieldRef}
					onFocus = {this.selectText.bind(this)}
					className = {this.props.classes.input}
				/>
				<ToolbarButton
					title = "Kopiera URL"
					icon = {<ClipboardIcon />}
					onClick = {this.copyTextAndClose.bind(this)}
				/>
				<ToolbarButton
					title = "Stäng"
					icon = {<CloseIcon />}
					onClick = {this.close.bind(this)}
				/>
			</Toolbar>
		)
	}

}

export default withStyles(styles)(Permalink)



// WEBPACK FOOTER //
// ./src/components/Stompunkt/Permalink.js